import {CA} from '../../../../shared/scripts/analytics/Analytics'
import {Sound} from '../../../../shared/scripts/Sound'
import {UIManager} from '../UIManager'
import {Scene} from '../UISceneTypes'

export class UIWLandingPageController {
    protected readonly uiManager: UIManager

    private readonly landingPageContainerDiv: HTMLDivElement
    protected readonly landingPageCTAMain: HTMLLinkElement
    private readonly enterMainPageButton: HTMLLinkElement
    private readonly botsCTA: HTMLLinkElement

    constructor(uiManager: UIManager) {
        this.uiManager = uiManager

        this.landingPageContainerDiv = document.getElementById('scene_landing_page_container') as HTMLDivElement
        this.enterMainPageButton = document.getElementById('landingpage_enter_mainpage_button') as HTMLLinkElement
        this.landingPageCTAMain = document.getElementById('landingpage_cta_main') as HTMLLinkElement
        this.botsCTA = document.getElementById('landingpage_cta_playvsbots') as HTMLLinkElement

        if(this.enterMainPageButton != undefined) {
            this.enterMainPageButton.onclick = () => {
                Sound.playSound(Sound.SoundType.Click)
                CA.sendGoogleAnalyticsEvent(CA.Category.LandingPage, CA.Label.ClickedEnterLobby)
                this.uiManager.sceneController.loadScene(Scene.MainPage)
            }
        }

        this.landingPageCTAMain.onclick = () => {
            Sound.playSound(Sound.SoundType.Click)
            this.clickLandingPageCTAMain()
        }

        this.botsCTA.onclick = () => {
            Sound.playSound(Sound.SoundType.Click)
            this.clickSinglePlayerCTA()
        }
    }

    protected clickLandingPageCTAMain() {
        CA.sendGoogleAnalyticsEvent(CA.Category.LandingPage, CA.Label.ClickedLandingPageMainCTA)
        this.uiManager.matchmakingController.showMatchmakingMatchTypeSelector()
    }

    // eslint-disable-next-line class-methods-use-this
    protected clickSinglePlayerCTA() {
        CA.sendGoogleAnalyticsEvent(CA.Category.LandingPage, CA.Label.ClickedLandingPageVSBots)

        this.uiManager.matchmakingController.selectMatchPopupView.showSinglePlayerOptions()
        this.uiManager.matchmakingController.selectMatchPopupView.show()
    }

    hide() {
        if(this.landingPageContainerDiv != undefined) this.landingPageContainerDiv.style.display = 'none'
    }

    show() {
        if(this.landingPageContainerDiv != undefined) this.landingPageContainerDiv.style.display = 'flex'
    }
}
